import styled from 'styled-components';

export const CustomDropdownWrapper = styled.div`
	position: relative;
	z-index: 11;

	input {
		padding: 8px;
		width: 300px;
	}

	.dropdown {
		position: absolute;
		top: 100%;
		left: 0px;
		width: 100%;
		max-height: 340px;
		overflow-y: auto;
		font-size: 13px;
    font-weight: 500;

	background: #FFFFFF;
box-shadow: 0px 1px 2px #00000017;
box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
border: 1px solid #D9D9D9;
border-radius: 5px;
	margin-top: 8px;
	&::-webkit-scrollbar {
  width: 0; 
  height: 0; 
}
	
	}

	.dropdown-option {
		padding: 4px 8px;
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 5px;
         &:nth-child(even){
			background-color: #e7e9eb8a;
		 }
		img {
			width: 34px;
		}
		&.active {
			color: #00baf2;
		}
	}

	.dropdown-option:hover {
	color: #00baf2;
	}
	@media only screen and (max-width: 620px) {
		.dropdown {
			width: 320px;
		}
	}

	@media only screen and (max-width: 480px) {
		.dropdown {
			width: 100%;
			
		}
	}
`;
